import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Elkana Tuwei`}</h1>
    <p>{`An innovative full-stack developer with strong background and expertise in backend development, web frameworks and cloud technologies.`}<br />{`
Skilled in building scalable applications with a focus on security and best coding practices.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      